export const MuiPaper = {
  styleOverrides: {
    root: {
      '@media (max-width:600px)': {
        borderRadius: '0px',
      },
    },
  },
};
